/* Admin (SYS1–SYS8): what the shared ops and close styles don't already cover. */

.filterGrid {
  composes: field-row from global;
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

@media (max-width: 720px) {
  .filterGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.tableFoot {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.selectedRow > td {
  background: var(--brand-cyan-50);
}

.selectedRow > td:first-child {
  box-shadow: inset 3px 0 0 var(--brand-cyan);
}

.tagList {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tagList > li {
  padding: 2px 8px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-pill);
  font-size: 12px;
  white-space: nowrap;
}

.notSet {
  color: var(--text-muted);
  font-style: italic;
}

.note {
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  background: var(--surface-subtle);
  font-size: 14px;
}

.panelHeading {
  margin: 16px 0 4px;
  color: var(--text-muted);
}

.facts {
  display: grid;
  gap: 6px;
  margin: 0;
}

.fact {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  gap: 12px;
  font-size: 14px;
}

.fact > dt {
  color: var(--text-muted);
}

.fact > dd {
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow-wrap: anywhere;
}

.roleList {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.roleList > li {
  display: flex;
  flex-direction: column;
}

.roleName {
  font-weight: 600;
}

/* Audit log */
/* One row of fields where they fit, as on SYS4 (Person · Area · Setting · Award · Period); labels
   line up across the row, and a field's hint hangs below it without moving the others. */
.auditFilters {
  composes: field-row from global;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 16px;
  align-items: start;
}

.chosen {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chosenValue {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-weight: 600;
}

.lockNotice {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 0;
  padding: 14px 18px;
  border-radius: var(--radius-md);
  background: var(--brand-navy);
  color: var(--text-on-dark);
  font-weight: 600;
}

.jsonFigure {
  margin: 12px 0;
}

.json {
  margin: 0;
  padding: 14px;
  border-radius: var(--radius-md);
  background: var(--surface-dark);
  color: var(--text-on-dark);
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* Roles & lists */
/* One column no wider than the card: a long name or Entra ID wraps instead of pushing the row's
   buttons out of it (APP-128). */
.memberList {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 4px;
  margin: 12px 0;
  padding: 0;
  list-style: none;
}

.member {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-card);
}

.memberText {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  overflow-wrap: anywhere;
}

.memberInline {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.avatar {
  display: inline-grid;
  flex: none;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 50%;
  background: var(--brand-navy);
  color: var(--text-on-dark);
  font-size: 12px;
  font-weight: 700;
}

.pickerRow {
  margin-top: 12px;
}

.histLine {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin: 12px 0 0;
}

.pickerPanel {
  display: grid;
  gap: 8px;
  justify-items: start;
  margin-top: 12px;
  padding: 14px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
  background: var(--surface-subtle);
}

.pickerPanel > p {
  margin: 0;
}

.pickerPanel > :not(p, button) {
  width: 100%;
}

.grantList {
  display: grid;
  gap: 2px;
  /* Room for a first and last name beside Remove, so most names stay on one line. */
  min-width: 220px;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* One person a line: the name on the left (it wraps when it must), Remove always at the right on
   the name's first line, whatever the name's length (SYS2). */
.grantList > li {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: start;
}

.grantName {
  /* Centred on the 44 px Remove button's first line. */
  padding-top: 11px;
  line-height: 22px;
}

/* "Alex Rivera · Jan 6, 2026" and its History button, apart and on one line while they fit. */
.lastChanged {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  align-items: center;
}

.adds {
  max-width: 280px;
  color: var(--text-muted);
  font-size: 13px;
}

.accessBody {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

.accessName {
  display: flex;
  flex-direction: column;
  margin: 0;
}

/* CSV import */
.drop {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 24px 16px;
  border: 1px dashed var(--border-dashed);
  border-radius: var(--radius-md);
  background: var(--surface-ground);
  color: var(--brand-petrol);
  text-align: center;
}

.drop[data-drop-target] {
  border-color: var(--brand-cyan);
  background: var(--brand-cyan-50);
}

.drop[data-focus-visible] {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 2px;
}

.dropText {
  color: var(--text-heading);
  font-weight: 600;
}

.fileRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
  color: var(--brand-petrol);
}

.fileText {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  color: var(--text-body);
  overflow-wrap: anywhere;
}

.tileButton {
  display: flex;
  flex-direction: column;
  min-height: 44px;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.tileButton[aria-pressed='true'] {
  border-color: var(--brand-cyan);
  box-shadow: 0 0 0 1px var(--brand-cyan);
}

.tileButton:focus-visible {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 2px;
}

.recentImports {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.recentImports > li {
  display: flex;
  flex-direction: column;
}

/* Directory sync: a filter rule's fields take its row, its Remove button at the end. */
.ruleFields {
  flex: 1 1 auto;
}

.pills {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin: 0;
}

.reportHeading {
  margin: 0 0 4px;
  color: var(--text-heading);
  font-size: 15px;
}

.referenceList {
  display: grid;
  gap: 10px;
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
}

.overridePanel {
  padding: 14px 16px;
  border: 1px solid var(--border-card);
  border-left: 4px solid var(--brand-gold);
  border-radius: var(--radius-md);
  background: var(--surface-subtle);
}

.overridePanel > p {
  margin: 4px 0;
}

.overrideTitle {
  margin: 0 0 4px;
  font-size: 16px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  padding-left: 12px;
  border: 1px solid var(--brand-cyan);
  border-radius: var(--radius-pill);
  background: var(--brand-cyan-50);
  color: var(--text-heading);
  font-size: 14px;
  font-weight: 600;
}

/* Award types & features */
.inlineEdit {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
  min-width: 180px;
}

.inlineForm {
  display: grid;
  gap: 10px;
  justify-items: start;
  margin: 8px 0 0;
}

.inlineForm > :first-child {
  width: min(100%, 420px);
}

.settingList {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.settingRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid var(--border-card);
}

.settingRow:last-child {
  border-bottom: 0;
}

.settingText {
  display: grid;
  flex: 1 1 260px;
  gap: 4px;
  min-width: 0;
}

.settingText > p {
  margin: 0;
}

.splashGroup {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(240px, 100%), 1fr));
  gap: 12px;
}

.splashField {
  display: grid;
}

.splashOption {
  display: grid;
  gap: 6px;
  align-content: start;
  min-height: 44px;
  padding: 14px 16px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
  cursor: pointer;
}

.splashOption[data-selected] {
  border-color: var(--brand-cyan);
  box-shadow: 0 0 0 1px var(--brand-cyan);
}

.splashOption[data-focus-visible] {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 2px;
}

.splashOption[data-disabled] {
  cursor: default;
}

.splashHead {
  color: var(--text-heading);
  font-family: var(--font-display);
  font-size: 16px;
}

.numberRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.or {
  padding-bottom: 12px;
  color: var(--text-muted);
}

.choiceList {
  margin: 12px 0 8px;
  padding-left: 22px;
  list-style: lower-alpha;
  font-size: 14px;
}

/* Console and go-live */
.stepList {
  display: grid;
  gap: 0;
  margin: 8px 0 12px;
  padding: 0;
  list-style: none;
}

.step {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-card);
}

.step:last-child {
  border-bottom: 0;
}

.stepCurrent {
  box-shadow: inset 3px 0 0 var(--brand-cyan);
  padding-left: 10px;
  background: var(--brand-cyan-50);
}

.stepNumber {
  display: inline-grid;
  flex: none;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid var(--border-card);
  border-radius: 50%;
  color: var(--text-heading);
  font-size: 13px;
  font-weight: 700;
}

.areaGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));
  gap: 12px;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

/* One settings area as SYS1 draws it: number and name on one line, what it holds, "Who edits",
   and the last change with History pinned to the foot over a rule. */
.areaTile {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
  background: var(--white);
}

.areaHead {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.areaNumber {
  color: var(--brand-petrol);
  font-family: var(--font-display);
  font-size: 15px;
  letter-spacing: 0.04em;
}

.areaEdits {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 13px;
}

.areaEyebrow {
  color: var(--text-muted);
  font-family: var(--font-ui);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.areaLast {
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid var(--border-subtle);
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.5;
}

.toolList {
  display: grid;
  gap: 0;
}

.tool {
  display: grid;
  gap: 8px;
  padding: 14px 0;
  border-bottom: 1px solid var(--border-card);
}

.tool:first-child {
  padding-top: 0;
}

.tool:last-child {
  border-bottom: 0;
}

.tool > p {
  margin: 0;
}

.linkList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

/* --- Admin tables (QA-034) ---------------------------------------------------------------------- */
/* They fit their column: no minimum width, long text wraps, and the last column, where the action
   or status is, stays on screen. Below 720 px they become card rows. A table that still can't fit
   scrolls inside its labelled region. */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table th,
.table td {
  padding: 10px 8px;
  border-bottom: 1px solid var(--border-hairline);
  text-align: left;
  vertical-align: middle;
  overflow-wrap: break-word;
}

.table thead th {
  color: var(--text-muted);
  font-family: var(--font-ui);
  font-size: 11px;
  font-weight: var(--fw-medium);
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* The row's action: as narrow as its button, never wrapped. In card rows (`data-card`, below
   720 px or in a narrow column) it sits at the bottom of the card at full width instead. */
.table .action:not([data-card]) {
  width: 1%;
  white-space: nowrap;
}

/* Only cells that hold long unbroken values (file names, hashes, emails, IDs) break anywhere, so
   they never widen the table; everything else wraps at spaces. */
/* Doubled for the cells themselves, which `.table td` would otherwise set back to break-word. */
.breakable,
.table .breakable {
  overflow-wrap: anywhere;
}

/* R152, R153: a technical value in the Audit log (an id, a fingerprint, a file name with an id)
   may break inside itself, so it never widens the table; the words around it wrap at spaces. */
.token {
  overflow-wrap: anywhere;
}

/* The action that leads an Audit log entry's "What changed" (R153). */
.actionLead {
  color: var(--text-heading);
  font-weight: var(--fw-semibold);
}

/* Numbers, dates and times stay whole, in even figures. */
.figure {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* An award type's name keeps room for two words a line, so no name runs past two lines (SYS5). */
.typeName {
  min-width: 150px;
}

/* Award types (SYS5): six columns since Recognize audience (APP-106), so a little less side padding
   keeps the table inside its card at 1280 with Help open. */
.typesTable th,
.typesTable td {
  padding-inline: 6px;
}

/* The audit entry: what changed, one line per part, and the raw JSON behind "View JSON". */
.changeList {
  display: grid;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.jsonDetails {
  margin: 12px 0;
}

.jsonDetails > summary {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--brand-navy);
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: var(--fw-medium);
  cursor: pointer;
}

.jsonDetails > summary:focus-visible {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 2px;
}

/* SYS5: a small picture of each sign-in design. */
.splashThumb {
  display: block;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-sm);
  background: var(--surface-dark);
}

.splashThumb > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.splashWall {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
}

/* --- Go-live checklist (FR5, QA-047): the 12 steps as a rail, the chosen step beside it ----- */

.checklistFrame {
  container-type: inline-size;
}

.checklist {
  display: grid;
  grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* The chosen step stays in view while the rail scrolls past it (under the Admin tabs). */
.checklistDetail {
  position: sticky;
  top: 76px;
  min-width: 0;
}

@container (max-width: 760px) {
  .checklist {
    grid-template-columns: minmax(0, 1fr);
  }

  .checklistDetail {
    position: static;
  }
}

.ringRow {
  display: flex;
  gap: 14px;
  align-items: center;
  margin: 4px 0 8px;
}

.ringWords {
  display: grid;
  gap: 2px;
  margin: 0;
}

.ring {
  position: relative;
  display: inline-grid;
  flex: none;
  width: 64px;
  height: 64px;
  place-items: center;
}

.ring > svg {
  position: absolute;
  inset: 0;
}

.ringTrack,
.ringDone {
  fill: none;
  stroke-width: 6;
}

.ringTrack {
  stroke: var(--border-card);
}

.ringDone {
  stroke: var(--brand-cyan);
  stroke-linecap: round;
}

.ringText {
  color: var(--text-heading);
  font-family: var(--font-display, inherit);
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.ringText > small {
  font-size: 12px;
  font-weight: 600;
}

.rail {
  display: grid;
  margin: 0 -24px -22px;
  padding: 0;
  border-top: 1px solid var(--border-card);
  list-style: none;
}

.railStep {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  min-height: 44px;
  padding: 10px 16px 10px 21px;
  border-bottom: 1px solid var(--border-card);
}

.railStep:last-child {
  border-bottom: 0;
}

.railCurrent {
  background: var(--brand-cyan-50);
  box-shadow: inset 3px 0 0 var(--brand-cyan);
}

.railMark {
  display: inline-grid;
  flex: none;
  width: 26px;
  height: 26px;
  place-items: center;
  border: 2px solid var(--border-control);
  border-radius: 50%;
  color: var(--text-heading);
  font-size: 12px;
  font-weight: 700;
}

.railMarkDone {
  border-color: transparent;
  background: var(--status-done-bg);
  color: var(--status-done-ink);
}

.railMarkOptional {
  border-style: dashed;
}

.railText {
  display: grid;
  flex: 1 1 auto;
  gap: 2px;
  min-width: 0;
}

/* A result can be one long word (the Executive group's address): it wraps, never widens the rail. */
.railResult {
  overflow-wrap: anywhere;
}

/* The whole row is the link's target (44 px and more); the name itself is at least 24 px tall,
   so it's a fair target on its own wherever the page is scrolled. */
.railLink {
  display: block;
  min-height: 24px;
  padding: 3px 0;
  color: var(--text-heading);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  text-decoration: none;
}

.railLink::after {
  content: '';
  position: absolute;
  inset: 0;
}

.railLink:hover {
  text-decoration: underline;
}

.railLink:focus-visible {
  outline: none;
}

.railStep:has(.railLink:focus-visible) {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: -2px;
}

.stepEyebrow {
  margin: 0;
  color: var(--text-secondary);
}

.stepPager {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--border-card);
}

.stepNext {
  margin-left: auto;
}

/* --- Go live ------------------------------------------------------------------------------- */

.liveFrame {
  container-type: inline-size;
}

.liveBody {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 340px);
  gap: 24px;
  align-items: start;
}

@container (max-width: 760px) {
  .liveBody {
    grid-template-columns: minmax(0, 1fr);
  }
}

.liveMain {
  display: grid;
  gap: 12px;
  justify-items: start;
  min-width: 0;
}

.liveMain > p,
.liveMain > div {
  justify-self: stretch;
  margin: 0;
}

.liveGate {
  display: grid;
  gap: 12px;
  padding: 18px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-sm);
  background: var(--surface-soft);
}

.liveGateHeading {
  margin: 0;
  color: var(--text-secondary);
}

.gateList {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.gateItem {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.gateNumber {
  display: inline-grid;
  flex: none;
  width: 24px;
  height: 24px;
  place-items: center;
  border: 2px solid var(--brand-gold-300);
  border-radius: 50%;
  color: var(--text-heading);
  font-size: 12px;
  font-weight: 700;
}

/* Not ready: grey with a lock, legible, beside the words that say why. */
button.lockedButton[data-disabled] {
  border-color: var(--border-control);
  background: var(--gray-75);
  color: var(--text-secondary);
  opacity: 1;
}

.gateNote {
  margin: 0;
  color: var(--text-heading);
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}

.previewModal {
  width: min(720px, 100%);
}

.previewFrame {
  display: block;
  width: 100%;
  height: min(560px, 60vh);
  border: 1px solid var(--border-card);
  border-radius: var(--radius-sm);
  background: var(--white);
}

/* A link onward to another page ("Open award history" and its arrow). */
.forwardLink {
  gap: 6px;
}

/* SYS3's sync numbers: one row of three, each number over its words. */
.syncNumbers {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

/* Each number over its words. The words come first in the markup (a dt before its dd), so the
   number moves up with `order`; a reversed column would sink a one-line label to the bottom and
   the three numbers would sit at different heights (APP-128). */
.syncNumbers > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.syncNumbers dt {
  color: var(--text-muted);
  font-size: 13px;
  line-height: 1.35;
}

.syncNumbers dd {
  order: -1;
  margin: 0;
  color: var(--text-heading);
  font-family: var(--font-display);
  font-size: 26px;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

/* SYS6's person on the navy band: initials, what they do, and their status and source chips. */
.personBand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.initials {
  display: grid;
  flex: none;
  place-items: center;
  width: 48px;
  height: 48px;
  border: 2px solid var(--brand-cyan);
  border-radius: 50%;
  background: var(--brand-navy-950);
  color: var(--white);
  font-family: var(--font-ui);
  font-size: 15px;
  letter-spacing: 0.04em;
}

.personBandText {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.personBandSub {
  margin: 0;
  color: var(--brand-mist);
  font-size: 13px;
  line-height: 1.45;
}

/* --- Starting setup file (APP-118): upload, the preview by checklist step, apply, Export --- */

.setupIntro {
  display: grid;
  gap: 12px;
}

.setupIntro > p {
  margin: 0;
}

/* Each status carries a word and an icon as well as its colour (never colour alone). */
.setupWill {
  --setup-bg: var(--status-info-bg);
  --setup-ink: var(--status-info-ink);
}

.setupSet {
  --setup-bg: var(--status-done-bg);
  --setup-ink: var(--status-done-ink);
}

.setupKept {
  --setup-bg: var(--status-neutral-bg);
  --setup-ink: var(--status-neutral-ink);
}

.setupCant {
  --setup-bg: var(--status-problem-bg);
  --setup-ink: var(--status-problem-ink);
}

/* APP-205: a setup apply's letters held for a person, said in the History (icon and words). */
.setupHeld {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  color: var(--status-problem-ink);
  font-size: 13px;
  font-weight: var(--fw-semibold);
}

.setupChip {
  display: inline-flex;
  flex: none;
  gap: 6px;
  align-items: center;
  align-self: start;
  min-height: 24px;
  padding: 2px 10px;
  border-radius: var(--radius-pill);
  background: var(--setup-bg);
  color: var(--setup-ink);
  font-size: 12px;
  font-weight: var(--fw-semibold);
  white-space: nowrap;
}

.setupCounts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(150px, 100%), 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.setupCount {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 2px 8px;
  align-items: center;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  background: var(--setup-bg);
  color: var(--setup-ink);
}

.setupCount > svg {
  grid-row: span 2;
}

.setupCountValue {
  font-size: 26px;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.setupCountLabel {
  font-size: 13px;
  font-weight: var(--fw-semibold);
}

/* A group's own counts: one line of small chips. */
.setupCountsCompact {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.setupCountsCompact .setupCount {
  display: inline-flex;
  gap: 6px;
  padding: 2px 10px;
  border-radius: var(--radius-pill);
  font-size: 12px;
}

.setupCountsCompact .setupCount > svg {
  grid-row: auto;
}

.setupCountsCompact .setupCountValue,
.setupCountsCompact .setupCountLabel {
  font-size: 12px;
  font-weight: var(--fw-semibold);
}

/* A zero reads as quiet, not as a status: grey, with its word still there. */
.setupCountNone {
  --setup-bg: var(--surface-soft);
  --setup-ink: var(--text-secondary);
}

.setupGroups {
  display: grid;
  gap: 16px;
}

.setupGroup {
  display: grid;
  gap: 10px;
  padding: 16px 18px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
}

.setupGroupHead {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: center;
  justify-content: space-between;
}

.setupGroupTitle {
  margin: 0;
  color: var(--text-heading);
  font-size: 16px;
  font-weight: var(--fw-semibold);
}

.setupEntries {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
}

.setupEntry {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid var(--border-card);
}

@media (max-width: 560px) {
  .setupEntry {
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
  }

  .setupChip {
    justify-self: start;
  }
}

.setupEntryText {
  display: grid;
  gap: 4px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.setupEntryText > p {
  margin: 0;
}

.setupEntryHead {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  align-items: baseline;
}

.setupValue {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  font-size: 14px;
}

.setupValue > svg {
  color: var(--text-secondary);
}

.setupMessage {
  color: var(--text-body);
  font-size: 14px;
}

.setupPlace {
  font-family: var(--font-mono);
  font-size: 12px;
}

.setupRefused {
  display: grid;
  gap: 8px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  background: var(--status-problem-bg);
  color: var(--status-problem-ink);
  font-size: 14px;
}

.setupRefused > p {
  margin: 0;
}

.setupRefusedTitle {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-weight: var(--fw-semibold);
}

.setupRefusedTitle > svg {
  flex: none;
  margin-top: 3px;
}

.setupRefusedList {
  display: grid;
  gap: 4px;
  margin: 0;
  padding-left: 26px;
  overflow-wrap: anywhere;
}

.setupRefusedNote {
  padding-left: 26px;
}

.setupRefusedPlace {
  font-weight: var(--fw-semibold);
}

/* The file's name and hash wrap above Check again on a phone instead of squeezing beside it. */
.setupFileText {
  flex: 1 1 220px;
}

.setupApply {
  display: grid;
  gap: 12px;
  justify-items: start;
}

.setupExport {
  display: grid;
  gap: 6px;
  justify-items: start;
}

.setupHistory {
  display: grid;
  gap: 12px;
}

.setupHistoryTitle {
  margin: 0;
  color: var(--text-secondary);
}

/* A later read of the card that failed: what was loaded stays, with Try again beside it. */
.setupStale {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;
}

/* Where focus lands after Apply: the done notice, read from its start. */
.setupLanding {
  display: grid;
}
